import { render, staticRenderFns } from "./SignUpSetPasscode.vue?vue&type=template&id=1c130fbd&scoped=true&"
import script from "./SignUpSetPasscode.vue?vue&type=script&lang=js&"
export * from "./SignUpSetPasscode.vue?vue&type=script&lang=js&"
import style0 from "./SignUpSetPasscode.vue?vue&type=style&index=0&id=1c130fbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c130fbd",
  null
  
)

export default component.exports